import { INTEGRATION_ENVIRONMENTS } from "@/data/integrationEnvironments";

const { sandbox_us, sandbox_ca } = INTEGRATION_ENVIRONMENTS;

export const generateAiContextBlock = (origin: string): string => {
  return `# Fullscript API integration context

You are helping integrate with the Fullscript partner REST API and related products (Embed, Redirect).

## Sources (fetch these; prefer over HTML scraping)
- OpenAPI: https://us.fullscript.com/docs/api/open-api/v1/openapi.json
- Doc index: ${origin}/llms.txt
- Environments JSON: ${origin}/integration-environments.json
- Human docs: ${origin}/docs/getting-started/for-ai/overview

## Auth (OAuth 2.0 authorization code)
- client_id + client_secret from Fullscript API Dashboard
- Authorize (browser redirect, US sandbox): ${sandbox_us.oauth_authorize}
- Token (US sandbox): POST ${sandbox_us.oauth_token}
- API base (US sandbox): ${sandbox_us.api_base}
- Canada sandbox API base: ${sandbox_ca.api_base}
- API calls: Authorization: Bearer <access_token>
- Auth codes expire in 10 minutes; exchange via POST /oauth/token with grant_type authorization_code

## Integration options
- Fullscript Embed (@fullscript/fullscript-js) or Redirect (new tab) OR direct REST
- Webhooks: verify Fullscript-Signature HMAC header

## Do not use
- /api/dashboard/* routes (internal API Dashboard BFF only)
- Hosts from OpenAPI "localhost" servers entries (local dev only)`;
};
